exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#StateListContainer[data-v-4a78af74] {\n  height: 12px;\n  width: 100%;\n  display: table;\n  table-layout: fixed;\n}\n.inlineBlock[data-v-4a78af74] {\n  display: table-cell;\n  box-sizing: border-box;\n  font-size: 1vh;\n}\n#confirmTestIcon[data-v-4a78af74] {\n  background-color: #ffbbbb; /* 配布物有りの背景色を設定 */\n}\n#hasMessage[data-v-4a78af74] {\n  background-color: #bbffbb; /* 連絡有りの背景色を設定 */\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-4a78af74","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/timetable/ReservationStates.vue
// module id = 509
// module chunks = 0